import * as React from 'react'
import { createFileRoute } from '@tanstack/react-router'
import { Header } from '@/components/layout/header'
import { CampaignList } from '@/components/whatsapp/campaign-list'
import { useWACampaignStats } from '@/hooks/useWACampaigns'

export const Route = createFileRoute('/whatsapp-campaigns')({
  component: WhatsAppCampaignsPage,
})

function WhatsAppCampaignsPage() {
  const { data: stats } = useWACampaignStats()

  const subtitle = stats
    ? `${stats.total} campaigns · ${stats.completed} completed`
    : 'Loading campaigns...'

  return (
    <div className="flex flex-col h-full">
      <Header title="Broadcast Campaigns" subtitle={subtitle} />
      <div className="flex-1 overflow-hidden">
        <CampaignList />
      </div>
    </div>
  )
}
